<template>
  <div class="animated revealUp">
    
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div>
        <div class="section-title">{{ $t('create') }} {{ $t('grn') }}</div>
      </div>
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-md-3 col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input placeholder="." type="text" disabled v-model="stock_in_details.cine_name" />
              <label>{{ $tc('cinema', 1) }}</label>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                disabled
                v-model="stock_in_details.v_name"
                v-validate="'required'"
              />
              <label>{{ $tc('vendor') }}</label>
            </div>
          </div>
        </div>

        <div class="col-md-3 col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input placeholder="." type="text" disabled v-model="stock_in_details.po_number" />
              <label>{{ $t('purchase', 1) }} {{ $t('order') }} {{ $t('number') }}</label>
            </div>
          </div>
        </div>

        <div class="col-md-3 col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker :monday-first="true"
                  ref="programaticOpen"
                  v-model="stock_in_details.po_date"
                  name="stockdate"
                  disabled
                  id="stockdate"
                ></Datepicker>
                <label
                  :class="stock_in_details.po_date ? 'active': ''"
                >{{$t('purchase') }} {{ $t('order') }} {{ $t('date') }}</label>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="storeManagementsLevels && Object.keys(storeManagementsLevels).length > 0 ? 'shift-up' : '' "
            >{{ $t('select') }} {{ $tc('store', 1) }}</label>
            <b-dropdown
              disabled
              :text="storeManagementsLevels.sm_store_name"
              variant="dropdown-curve"
              class="w-100"
            ></b-dropdown>
          </div>
        </div>

        <div class="col-md-3 col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker :monday-first="true"
                  ref="programaticOpen"
                  v-model="stock_in_details.stock_in_date"
                  name="stockdate"
                  disabled
                  id="stockdate"
                  v-validate="'required'"
                ></Datepicker>
                <label
                  :class="stock_in_details.stock_in_date ? 'active': ''"
                >{{$t('stock') }} {{ $t('in') }} {{ $t('date') }}</label>
              </div>
            </div>
            <!-- <Tooltip :title="$t('stockindate_updatestockin')" />-->
          </div>
          <p
            v-if="submitted && errors.has('stockdate')"
            class="error_message"
          >{{ errors.first('stockdate') }}</p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="stock_in_details.stock_in_expiry_date"
                  v-on:click="clearSelectedDate1()"
                >✖</button>
                <Datepicker :monday-first="true"
                  ref="programaticOpen"
                  v-model="stock_in_details.stock_in_expiry_date"
                  name="expirydate"
                  id="expirydate"
                  typeable
                  v-validate="stock_in_details.is_expiry_available == 'Y' ? 'required' : ''"
                ></Datepicker>
                <label
                  :class="stock_in_details.stock_in_expiry_date ? 'active': ''"
                >{{$t('stock') }} {{ $t('in') }} {{ $t('expiry') }} {{ $t('date') }}</label>
              </div>
            </div>
            <Tooltip :title="$t('expirydate_updatestockin')" />
          </div>
          <p v-if="stock_in_details.is_expiry_available == 'Y'" class="error_message">
            <span v-if="submitted && errors.has('expirydate')">{{ errors.first('expirydate') }}</span>
          </p>
          <p v-else class="error_message">
            <span></span>
            <!-- <span v-if="submitted && errors.has('expirydate')">{{ errors.first('expirydate') }}</span> -->
          </p>
        </div>

        <div class="col-md-3 col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-validate="'required|alpha_num'"
                name="invoicenumber"
                id="invoicenumber"
                v-model="stock_in_details.invoice_number"
              />
              <label>{{ $t('invoice')}} {{ $t('number') }}</label>
            </div>
          </div>
          <p class="error_message">
            <span
              v-if="submitted && errors.has('invoicenumber')"
            >{{ errors.first('invoicenumber') }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="stock_in_details.invoice_date"
                  v-on:click="clearInvoiceDate()"
                >✖</button>
                <Datepicker :monday-first="true"
                  ref="programaticOpen"
                  v-model="stock_in_details.invoice_date"
                  name="invoicedate"
                  id="invoicedate"
                  typeable
                  v-validate="'required'"
                  :disabled-dates="disabledDates"
                ></Datepicker>
                <label
                  :class="stock_in_details.invoice_date ? 'active': ''"
                >{{$t('invoice') }} {{ $t('date') }}</label>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('invoicedate')">{{ errors.first('invoicedate') }}</span>
          </p>
        </div>

        <div class="col-md-12 mb-4 pt-3 bg-light rounded">
          <div class="row">
            <div class="col-12 mb-3 font-weight-bold">{{ $t('item') }}</div>
            <div class="col-md-3 mb-3">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    type="text"
                    disabled
                    v-model="stock_in_details.rm_name"
                    v-validate="'required'"
                  />
                  <label class="bg-light">{{ $tc('rawmaterials', 1) }}</label>
                </div>
              </div>
              <small
                v-if="stock_in_details.rm_name && stock_in_details.rm_name.length > 0"
              >(Max transfer Quantity {{poi_qty}})</small>
            </div>

            <div class="col-md-3 mb-3">
              <div class="dropdown-curve-container">
                <div class="input-material">
                  <!-- <b-input-group> -->
                  <input
                    v-model="stock_in_details.stock_in_quantity"
                    style="border-radius:10px;"
                    type="text"
                    v-validate="'required|numeric'"
                    name="stockquantity"
                    id="stockquantity"
                    @input="CalculateSelectedRawMaterial($event.target.value)"
                    placeholder="Qty"
                  />
                  <label
                    class="bg-light"
                    :class="stock_in_details.stock_in_quantity && String(stock_in_details.stock_in_quantity).length > 0 ? 'shift-up' : '' "
                  >{{ $t('stockinQuantity') }}</label>
                  <!-- <template v-slot:append>
                      <b-dropdown variant="dropdown-curve" class="w-100">
                        <b-dropdown-item
                          v-for="(loop, index) in poi_qty"
                          :key="index"
                          v-on:click="onSelectQty(loop)"
                        >{{ loop}}</b-dropdown-item>
                      </b-dropdown>
                  </template>-->
                  <!-- </b-input-group> -->
                </div>
                <!-- {{stock_in_details.stock_in_quantity}} -->
                <p class="error_message">
                  <span
                    v-if="submitted && errors.has('stockquantity')"
                  >{{ errors.first('stockquantity') }}</span>
                </p>
              </div>
            </div>

            <div class="col-md-3 mb-3">
              <div class="dropdown-curve-container">
                <div class="input-material">
                  <!-- <b-input-group> -->
                  <input
                    v-model="stock_in_details.batch_number"
                    style="border-radius:10px;"
                    type="text"
                    name="batchnumber"
                    id="batchnumber"
                    placeholder="Batch Number"
                  />
                  <label
                    class="bg-light"
                    :class="stock_in_details.batch_number && String(stock_in_details.batch_number).length > 0 ? 'shift-up' : '' "
                  >{{ $t('enter') }} {{ $t('batch') }} {{ $t('number') }}</label>
                  <!-- </b-input-group> -->
                </div>
                <p class="error_message">
                  <span></span>
                  <!-- <span
                    v-if="submitted && errors.has('batchnumber')"
                  >{{ errors.first('batchnumber') }}</span>-->
                </p>
              </div>
            </div>

            <div class="col-md-3 mb-3">
              <div class="dropdown-curve-container">
                <label
                  class="bg-light"
                  :class="stock_in_details.uom_unit && stock_in_details.uom_unit.length > 0 ? 'shift-up' : '' "
                >{{ $t('unit') }}</label>
                <b-dropdown
                  disabled
                  :text="stock_in_details.uom_unit"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <b-dropdown-item
                    v-for="(uom, uomKey) in UomList"
                    :key="uomKey"
                    v-on:click="onSelectUnitOfM(uom)"
                  >{{ uom.uom_short_form }}</b-dropdown-item>
                </b-dropdown>
              </div>
            </div>

            <div class="col-md-3 mb-3">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    v-model="stock_in_details.poi_price"
                    type="text"
                    name="totalrate"
                    id="totalrate"
                    placeholder="."
                    disabled
                  />
                  <label class="bg-light">{{ $t('netAmount') }}</label>
                </div>
              </div>
              <p class="error_message">
                <span></span>
              </p>
            </div>

            <div class="col-md-3 mb-3">
              <div class="input-material">
                <input
                  v-model="stock_in_details.poi_tax_amount"
                  type="text"
                  name="totalrate"
                  disabled
                  id="totalrate"
                  placeholder="."
                />
                <label class="bg-light">{{ $t('tax') }}</label>
              </div>
              <p class="error_message">
                <span></span>
              </p>
            </div>

            <div class="col-md-3 mb-3">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    v-model="stock_in_details.poi_total_amount"
                    type="text"
                    name="totalrate"
                    id="totalrate"
                    disabled
                    placeholder="."
                  />
                  <label class="bg-light">{{ $t('totalamount') }}</label>
                </div>
              </div>
              <p class="error_message">
                <span></span>
              </p>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            @click.prevent.stop="OnFinalSubmit()"
            :disabled="disableSubmit"
            class="btn-blue"
          >{{ $t('submit') }}</button>
          <b-button class="btn-outline-grey" variant="default" to="stock-in">{{ $t('cancel') }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import PosFnbService from "@/services/PosFnbService";
import MasterService from "@/services/MasterService";
export default {
  data() {
    return {
      submitted: false,
      disableSubmit: false,
      stock_in_details: {
        batch_number: null,
        invoice_number: null,
        invoice_date: null,
      },
      disabledDates: {
        from: new Date(),
      },
      stock_in_details_copy: {},
      stock_in_id: "",
      po_id: "",
      rm_id: "",
      poi_qty: "",
      UomList: [],
      storeManagementsLevels: {},
      sigle_rate_net:0,
      single_total_amount:0,
      single_rate_tax:0
    };
  },
  beforeMount() {
    this.stock_in_id = this.$route.query.stock_in_id;
    this.po_id = this.$route.query.po_id;
    this.rm_id = this.$route.query.rm_id;
  },
  mounted() {
    this.getStockInDetails();
    this.getUoM();
  },
  methods: {
    clearInvoiceDate() {
      this.stock_in_details.invoice_date = "";
    },
    clearSelectedDate: function () {
      this.stock_in_details.stock_in_date = "";
    },
    clearSelectedDate1: function () {
      this.stock_in_details.stock_in_expiry_date = "";
    },
    getStockInDetails: function () {
      let payload = {
        po_id: this.po_id,
        rm_id: this.rm_id,
      };
      PosFnbService.GetStockInDetails(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.stock_in_details = data.Records[0];
            console.log("this.stock_in_details :>> ", this.stock_in_details);
            this.stock_in_details_copy = data.Records[0];
            this.getParentStore(data.Records[0].cinema_id);
            this.stock_in_details.stock_in_date === null
              ? (this.stock_in_details.stock_in_date = new Date())
              : this.stock_in_details.stock_in_date;
            this.GetUomForStockIn(this.stock_in_details);

          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          this.$toasted.show(err);
        });
    },
    getParentStore: function (cinema_id) {
      let payload = {
        tableName: "store_management",
        sm_is_active: "Y",
        cinema_id: cinema_id,
        sm_parent_id: 0,
        sm_order: 1,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.storeManagementsLevels = data.Records[0];
          } else if (data.Records.length == 0) {
            this.$toasted.show(
              "Please create one main store to transfer stock into"
            );
            setTimeout(() => {
              this.$router.go(-1);
            }, 100);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    GetUomForStockIn: function (stock_in_details) {
      let payload = {
        rm_id: stock_in_details.rm_id,
        po_id: stock_in_details.po_id,
      };
      PosFnbService.GetUomForStockIn(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.stock_in_details["uom_id"] = data.Records[0].uom_id;
              this.stock_in_details["uom_unit"] =
                data.Records[0].uom_short_form;
              this.poi_qty = this.stock_in_details.sum_stock_in_quantity;
              this.stock_in_details.stock_in_quantity = this.stock_in_details.sum_stock_in_quantity;
              console.log("this.stock_in_details :>> ", this.stock_in_details);
              this.sigle_rate_net=+parseFloat(this.stock_in_details["poi_price"]/this.stock_in_details["poi_qty"]).toFixed(1);
      this.single_rate_tax=+parseFloat(this.stock_in_details["poi_tax_amount"]/this.stock_in_details["poi_qty"]).toFixed(1);
     this.single_total_amount=+parseFloat(this.stock_in_details["poi_total_amount"]/this.stock_in_details["poi_qty"]).toFixed(1);
              this.CalculateSelectedRawMaterial(this.stock_in_details.stock_in_quantity)
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          this.$toasted.show(err);
        });
    },
    getUoM: function () {
      let payload = {
        tableName: "ms_unit_of_measurement",
        uom_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.UomList = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onSelectQty: function (qty) {
      this.stock_in_details["stock_in_quantity"] = qty;
    },
    onSelectUnitOfM: function (params) {
      this.stock_in_details["uom_id"] = params.uom_id;
      this.stock_in_details["uom_unit"] = params.uom_unit;
    },
    CalculateSelectedRawMaterial: function (params) {
      if (this.poi_qty && params > this.poi_qty) {
        this.stock_in_details["stock_in_quantity"] = this.poi_qty;
        this.$toasted.show("Max quantity is " + this.poi_qty);
      } else {
        this.stock_in_details["stock_in_quantity"] = params;
      }
      
      console.log(this.sigle_rate_net,this.single_rate_tax,this.single_total_amount);
      this.stock_in_details["poi_price"]=this.sigle_rate_net*this.stock_in_details["stock_in_quantity"]
      this.stock_in_details["poi_tax_amount"]=this.single_rate_tax*this.stock_in_details["stock_in_quantity"]
      this.stock_in_details["poi_total_amount"]=this.single_total_amount*this.stock_in_details["stock_in_quantity"]

      console.log(this.stock_in_details)
    },
    resetForm: function () {
      this.stock_in_details = {};
    },
    OnFinalSubmit: function () {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        console.log("valid :>> ", valid);
        if (valid) {
          console.log(
            "this.stock_in_details.stock_in_quantity :>> ",
            this.stock_in_details.stock_in_quantity
          );
          if (this.stock_in_details.stock_in_quantity > 0) {
            this.disableSubmit = true;
            let payload = {
              ...this.stock_in_details,
              stock_in_id: this.stock_in_id,
              sm_id: this.storeManagementsLevels.sm_id,
              poi_qty: this.poi_qty,
            };
            PosFnbService.updatStockinDetails(payload)
              .then((response) => {
                const { data } = response;
                this.disableSubmit = false;
                if (data && data.status) {
                  this.$toasted.show(data.message);
                  this.$router
                    .push({
                      path: "stock-in",
                    })
                    .catch((err) => {
                      console.log("err :>> ", err);
                    });
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch((err) => {
                this.disableSubmit = false;
                this._CatchError;
              }); //message
          } else {
            this.disableSubmit = false;
            this.$toasted.show("Stock In Quantity cannot be 0");
          }
        }
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/StockComponents/updateStockIn.vue